import React from 'react';
import { useSelector } from 'react-redux';

// Components

import BlockWrapper from './BlockWrapper';

// Styles

import { darculaIdsInfoStyles } from '../darculaTheme';

// Utils

import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';

const {
    blockWrapperAdditionalStyles,
    applicationIdRowStyle,
    applicationIdValueStyle,
    memberListContainerStyle,
    memberRowStyle,
    memberNameStyle,
    memberPersonIdStyle,
    memberGuidStyle,
} = darculaIdsInfoStyles;

const IdsInfo = ({ id }) => {

    const data = useSelector(state => state.ssap.data);
    const { ssapApplicationId } = data;

    const getIds = () => {
        return data
            .taxHousehold
            .householdMember
            .map(hhm => {
                const {
                    applicantGuid,
                    personId,
                    name
                } = hhm;

                return (
                    <div key={ `${applicantGuid}_${personId}` } style={ memberRowStyle }>
                        <span style={ memberNameStyle }>
                            { normalizeNameOfPerson(name) }
                        </span>
                        <span style={ memberPersonIdStyle }>
                            ID: &nbsp; { personId }
                        </span>
                        <span style={ memberGuidStyle }>
                            GUID: &nbsp; { applicantGuid }
                        </span>
                    </div>
                );
            });
    };

    return (
        <BlockWrapper
            id={ id }
            additionalStyles={ blockWrapperAdditionalStyles }
        >
            <div style={ applicationIdRowStyle }>
                SSAP Application ID: &nbsp;
                <strong style={ applicationIdValueStyle }>
                    { ssapApplicationId }
                </strong>
            </div>
            <div style={ memberListContainerStyle }>
                { getIds() }
            </div>
        </BlockWrapper>
    );

};

export default IdsInfo;
